import React from "react";

const News = () => {
    return (
        <div className="news-container">
            <img style={{borderRadius:'20px'}} src="https://img.freepik.com/free-photo/cartoon-students-school_23-2151657414.jpg?ga=GA1.1.1133403417.1726468731&semt=ais_hybrid" alt="" />
        </div>
    );
};

export default News;
